import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';

import {
  LOAD_AUDIENSES
} from './constants';

import {
  loadAudiencesSuccess,
  loadAudiencesError,
} from './actions';

export function* loadListSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { params } = action;
    let itemsList = false;
    let convertParams = { ...params };
    
    if (typeof params?.filterValue === 'string') {
      convertParams.filterValue = params?.filterValue.split(',');
    }

    // we get the campaigns linked to the communications
    if ( params ) {
      itemsList = yield requestWrapper(
        'POST',
        `audiences/list`,
        convertParams || params,
        currentUser.token,
      );
    } else {
      itemsList = yield requestWrapper(
        'GET',
        `audiences/list`,
        '',
        currentUser.token,
      );
    }

    if (!itemsList) {
      yield put(loadAudiencesSuccess(false));
    } else {
      yield put(loadAudiencesSuccess(itemsList, itemsList?.docs, params));
    }
  } catch (error) {
    yield put(loadAudiencesError(error));
  }
}


export default function* audiencesSaga() {
  yield takeLatest(LOAD_AUDIENSES, loadListSaga);
}
